import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  doc: null,
  token: null,
};

const reducer = (state = INITIAL_STATE, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case '@customer/SIGN_IN_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@customer/SIGN_IN_SUCCESS': {
        draft.loading = false;
        draft.token = action.payload.token;
        draft.doc = action.payload.doc;
        break;
      }
      case '@customer/FAILURE': {
        draft.loading = false;
        draft.token = null;
        break;
      }

      default:
        break;
    }
  });

export default reducer;
